import { createReducer, on } from '@ngrx/store';
import * as fromHistoryActions from '../actions/history.action'
import { FilterDate, FilterType } from 'src/app/pages/home/transaction-history/transaction-history.page';

export const featureKey = 'history';

export interface State {
    filter: {
        filterType: FilterType,
        filterDate: FilterDate
    }
    // filter: {}
}

export const initialState: State = {
    filter: {
        filterType: null,
        filterDate: null
    }
};

export const reducer = createReducer(
    initialState,
    on(fromHistoryActions.setFilterDate, (state: State, props: any) => {
        console.log("is this exectured??");
        return {
        ...state,
        filter: {...state.filter, filterDate: props.data}
        }
    }),
    on(fromHistoryActions.setFilterType, (state: State, props: any) => {
        console.log(props);
        return {
            ...state,
            filter: { ...state.filter, filterType: props.data}
        }
    }),
);
